import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import logger from "@insite/client-framework/Logger";
import { getExpediteShipping } from "@TKCCP/Services/tkccpExpediteShippingService";
import { ExpediteShippingModel } from "@TKCCP/Types/ApiModels";

type HandlerType = Handler<
    {
        cartId: string;
    },
    {
        expediteShipping?: ExpediteShippingModel;
    }
>;

const isNotFoundResponse = (error: any) => error && error.status === 404;

export const DispatchBeginLoadExpediteShipping: HandlerType = props => {
    props.dispatch({
        type: "Data/ExpediteShipping/BeginLoadExpediteShipping" as any,
        cartId: props.parameter.cartId,
    });
};

export const GetExpediteShipping: HandlerType = async props => {
    try {
        props.expediteShipping = await getExpediteShipping({
            cartId: props.parameter.cartId,
        });
       
    } catch (error) {
        if (isNotFoundResponse(error)) {
            logger.info(`The product with id "${props.parameter.cartId}" does not have product extension data.`);
        } else {
            throw error;
        }
    }
};

export const DispatchCompleteLoadExpediteShipping: HandlerType = props => {
    props.dispatch({
        type: "Data/ExpediteShipping/CompleteLoadExpediteShipping" as any,
        cartId: props.parameter.cartId,
        model: props.expediteShipping as any,
    });
};

 export const chain = [DispatchBeginLoadExpediteShipping, GetExpediteShipping, DispatchCompleteLoadExpediteShipping];
//export const chain = [DispatchBeginLoadExpediteShipping, DispatchCompleteLoadExpediteShipping];
const loadExpediteShipping = createHandlerChainRunner(chain, "LoadExpediteShipping");
export default loadExpediteShipping;
